import Vue from "vue";
import Vuetify from "vuetify/lib";
import variables from "../styles/_variables.scss";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi"
  },
  theme: {
    light: true,
    themes: {
      light: {
        primary: variables.primaryColor,
        secondary: variables.secondaryColor,
        accent: variables.accentColor,
        error: variables.errorColor,
        info: variables.infoColor,
        success: variables.successColor,
        warning: variables.warningColor
      }
    }
  }
});
